import React from 'react';
import { useTranslation } from 'react-i18next';
import Input from 'components/input/input.component';
import { IKpu } from 'interfaces/applicant.interface';

interface IProps {
  kpu: IKpu;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

const RestConnection: React.FC<IProps> = ({ kpu, handleChange }) => {
  const { t } = useTranslation();

  // IP and Port stay untranslated: they are protocol terms, not UI copy.
  return (
    <>
      <Input name="ip" value={kpu.ip || ''} label={'IP'} onChange={handleChange} />
      <Input name="port" value={kpu.port || ''} label={t('dashboard.port')} onChange={handleChange} />
      <Input name="login" value={kpu.login || ''} label={t('dashboard.login')} onChange={handleChange} />
      <Input name="pass" value={kpu.pass || ''} label={t('auth.password')} onChange={handleChange} />
    </>
  );
};

export default RestConnection;
